import { render, staticRenderFns } from "./DepartPost.vue?vue&type=template&id=982b9340&scoped=true&"
import script from "./DepartPost.vue?vue&type=script&lang=js&"
export * from "./DepartPost.vue?vue&type=script&lang=js&"
import style0 from "./DepartPost.vue?vue&type=style&index=0&id=982b9340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982b9340",
  null
  
)

export default component.exports